// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#links[data-v-189edd22] {\n    display: flex;\n    align-items: stretch;\n    align-content: stretch;\n}\n#actions[data-v-189edd22] {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n#actions > button[data-v-189edd22] {\n        background-color: var(--white);\n        width: 100%;\n        margin-bottom: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
